import React, { ReactElement } from 'react';
import classNames from 'classnames';
import { Iframe as IframeComponent } from 'b2b-components/theme/components/CMS/Iframe';
import { isEmpty } from 'b2b-apps/shop/common/utils/empty/empty';
import { createKey } from 'b2b-apps/shop/common/utils/key/key';
import { ComponentType, Props } from './';

const Iframe: ComponentType = ({
  className,
  componentData: data,
}: Props): ReactElement | null => {
  if (isEmpty(data)) {
    return null;
  }

  return (
    <div className={classNames('cds-cms-GridRow', className)}>
      <div className="cds-cms-IframeContainer">
        <IframeComponent
          height={data.height ? `${data.height}px` : undefined}
          key={createKey('iframe', data.iframe_url)}
          url={data.iframe_url}
        />
      </div>
    </div>
  );
};

export { Iframe };
